export default __webpack_public_path__ + "static/app-screen-5-535d78dcc46b2774e4ad15136677e66b.png";